
import {Component} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import DebounceMixin from '@/mixins/DebounceMixin';
import LoadingMixin from '@/mixins/LoadingMixin';
import SnackbarMixin from '@/mixins/SnackbarMixin';
import {swalConfirm, swalError} from '@/plugins/swal';

interface MessageCheckUser {
  pesan: string[];
}
@Component
export default class Dashboard extends mixins(
  LoadingMixin,
  SnackbarMixin,
  DebounceMixin,
) {
  locationItems = [];
  jobsItems = {
    job_position: {name: ''}, // Inisialisasi properti yang diperlukan
    city: '',
    description: '',
    gender: '',
    age_min: 0,
    age_max: 0,
    education: '',
    ipk: 0,
    work_experience: '',
    marital_status: '',
    due_date: '',
    salary_min: 0,
    salary_max: 0,
  };
  messageCheckUser: MessageCheckUser = {pesan: []}; // Initialize with default values
  isLoadedCheckProgress = false;
  category = '';
  location = null;
  jobtype = null;
  items = [
    {
      src:
        'https://www.dictio.id/uploads/db3342/original/3X/6/b/6b3194ebea481506686ea44c0c76d00b89542529.jpeg',
    },
  ];
  // cek git
  currentPage = 1;
  maxPerPage = 3;
  showReadMore = true;
  orders = 10;
  get idJob() {
    return this.$route.params.id;
  }
  async mounted() {
    await this.fetchDetail();
    await this.checkProgress();
  }
  async fetchDetail() {
    try {
      this.startLoading('detail');
      const {data} = await this.$store.dispatch('jobs/detail', this.idJob);
      this.finishLoading('detail');
      this.jobsItems = data;
    } catch (e) {
      this.catchError(e);
    }
  }
  async checkProgress() {
    try {
      this.startLoading('detail');
      const {data} = await this.$store.dispatch('jobs/checkProgress');
      this.finishLoading('detail');
      this.messageCheckUser = data;
      this.isLoadedCheckProgress = true;
    } catch (e) {
      this.catchError(e);
    }
  }
  async onSubmit() {
    const {value: confirmed} = await swalConfirm.fire({
      text: 'Apakah anda yakin ingin daftar pekerjaan ini?',
      confirmButtonText: 'Ya',
      cancelButtonText: 'Tidak',
    });
    if (confirmed) {
      this.applyJobs();
    }
  }
  async applyJobs() {
    try {
      this.startLoading('saving');

      const form = {
        jobvacancy_id: this.$route.params.id,
      };

      const res = await this.$store.dispatch('jobs/applyJobs', form);

      if (res.status === 200) {
        this.finishLoading('saving');
        this.handleSuccess(res.data.message); // menampilkan pesan sukses ke snackbar
        this.$router.push('/aplication');
      } else if (res.status === 400) {
        this.finishLoading('saving');
        this.$snackbar.show(
          res.data.message || 'Something went wrong',
          'error',
        ); // menampilkan pesan error ke snackbar
      } else {
        this.finishLoading('saving');
        this.$snackbar.show(res.message, 'error'); // menampilkan pesan error ke snackbar
      }
    } catch (e) {
      this.finishLoading('saving');
      this.$snackbar.show(
        e.response?.data?.message || 'An unexpected error occurred.',
        'error',
      ); // menampilkan error ke snackbar
    }
  }
}
